export default function ipfsToPath(url) {
    return url?.replace('ipfs://', "https://ipfs.io/ipfs/");
}
